/* AOV 23 — Build your set (sections/runit-build-your-set.liquid).
   Each set is a list of slots; a slot is a design picker (from one collection) plus the product's
   own option buttons (Size, Print Finish, Colour). Prices come from /products/<handle>.js, so the
   total is what the bag will charge before the set's saving. "Add set to bag" posts every chosen
   variant in one /cart/add.js call; every saving is an automatic discount. */
(function () {
  var root = document.querySelector('[data-runit-build-set]');
  if (!root) return;
  var LISTS = JSON.parse(root.querySelector('[data-set-lists]').textContent);
  var SETS = {
    'hoodie-tee': { slots: [['offer-hoodies', 'Hoodie'], ['offer-tees', 'Matching tee']], save: function (p) { return Math.min(500, p[1]); }, note: '£5 off the tee' },
    'two-hoodies': { slots: [['offer-hoodies', 'First hoodie'], ['offer-hoodies', 'Second hoodie']], save: function () { return 1000; }, note: '£10 off' },
    'three-tees': { slots: [['offer-tees', 'First tee'], ['offer-tees', 'Second tee'], ['offer-tees', 'Third tee']], save: function () { return 500; }, note: '£5 off' }
  };
  var slotsEl = root.querySelector('[data-set-slots]'), totalEl = root.querySelector('[data-set-total]');
  var addBtn = root.querySelector('[data-set-add]'), msgEl = root.querySelector('[data-set-msg]');
  var cache = {}, state = { set: 'hoodie-tee', slots: [] };

  function money(c) { return '£' + (c / 100).toFixed(c % 100 ? 2 : 0); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function product(handle) {
    if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
    return cache[handle];
  }

  // The variant matching the slot's chosen options, or null until every option is chosen.
  function variantOf(slot) {
    if (!slot.p) return null;
    return slot.p.variants.find(function (v) {
      return v.available && v.options.every(function (o, i) { return slot.opts[i] === o; });
    }) || null;
  }

  function renderSlot(i) {
    var slot = state.slots[i], el = slotsEl.children[i];
    var body = el.querySelector('[data-slot-body]');
    if (!slot.p) { body.innerHTML = ''; el.querySelector('[data-slot-img]').hidden = true; return; }
    var img = el.querySelector('[data-slot-img]');
    img.src = (slot.p.featured_image || '').replace(/^\/\//, 'https://') + (slot.p.featured_image && slot.p.featured_image.indexOf('?') < 0 ? '?width=240' : '');
    img.hidden = false;
    body.innerHTML = slot.p.options.map(function (opt, oi) {
      var values = opt.values.filter(function (val) {
        return slot.p.variants.some(function (v) { return v.available && v.options[oi] === val; });
      });
      return '<fieldset class="rl-set__opt"><legend class="rl-set__label">' + esc(opt.name) + '</legend><div class="rl-set__vals">' +
        values.map(function (val) {
          var id = 'rl-set-' + i + '-' + oi + '-' + val.replace(/\W+/g, '');
          return '<input type="radio" id="' + id + '" name="rl-set-' + i + '-' + oi + '" value="' + esc(val) + '"' + (slot.opts[oi] === val ? ' checked' : '') + '>' +
            '<label for="' + id + '">' + esc(val) + '</label>';
        }).join('') + '</div></fieldset>';
    }).join('');
    body.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var oi = +inp.name.split('-').pop(), name = slot.p.options[oi].name;
        slot.opts[oi] = inp.value;
        // Same option still unset elsewhere in the set (e.g. the tee's Size): fill it in too.
        state.slots.forEach(function (o, j) {
          if (j === i || !o.p) return;
          var k = o.p.options.findIndex(function (x) { return x.name === name; });
          if (k > -1 && !o.opts[k] && o.p.options[k].values.indexOf(inp.value) > -1) { o.opts[k] = inp.value; renderSlot(j); }
        });
        total();
      });
    });
  }

  function choose(i, handle) {
    var slot = state.slots[i];
    slot.h = handle; slot.p = null; slot.opts = [];
    renderSlot(i); total();
    if (!handle) return;
    product(handle).then(function (p) {
      if (slot.h !== handle) return;
      slot.p = p;
      slot.opts = p.options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
      // Carry the size (and finish) across slots so a set is quick to fill.
      var prev = state.slots.find(function (s, j) { return j !== i && s.p; });
      if (prev) p.options.forEach(function (o, oi) {
        var match = prev.p.options.findIndex(function (po) { return po.name === o.name; });
        if (match > -1 && prev.opts[match] && o.values.indexOf(prev.opts[match]) > -1 && !slot.opts[oi]) slot.opts[oi] = prev.opts[match];
      });
      renderSlot(i); total();
      // Hoodie + tee: pick the matching tee for the chosen hoodie.
      if (state.set === 'hoodie-tee' && i === 0) {
        var item = LISTS['offer-hoodies'].find(function (x) { return x.h === handle; });
        var sel = slotsEl.children[1] && slotsEl.children[1].querySelector('select');
        if (item && item.c && sel && LISTS['offer-tees'].some(function (x) { return x.h === item.c; })) { sel.value = item.c; choose(1, item.c); }
      }
    });
  }

  function build() {
    var set = SETS[state.set];
    state.slots = set.slots.map(function () { return { h: '', p: null, opts: [] }; });
    slotsEl.innerHTML = set.slots.map(function (s, i) {
      var list = LISTS[s[0]] || [];
      return '<div class="rl-set__slot"><div class="rl-set__slot-head"><img class="rl-set__img" data-slot-img alt="" width="120" height="120" hidden>' +
        '<label class="rl-set__pick"><span class="rl-set__label">' + (i + 1) + '. ' + esc(s[1]) + '</span>' +
        '<select><option value="">Choose a design</option>' + list.map(function (x) { return '<option value="' + esc(x.h) + '">' + esc(x.t) + '</option>'; }).join('') + '</select></label></div>' +
        '<div class="rl-set__body" data-slot-body></div></div>';
    }).join('');
    Array.prototype.forEach.call(slotsEl.querySelectorAll('select'), function (sel, i) {
      sel.addEventListener('change', function () { choose(i, sel.value); });
    });
    total();
  }

  function total() {
    var set = SETS[state.set], vs = state.slots.map(variantOf), all = vs.every(Boolean);
    var prices = vs.map(function (v) { return v ? v.price : 0; });
    var sum = prices.reduce(function (a, b) { return a + b; }, 0), save = all ? set.save(prices) : 0;
    msgEl.textContent = '';
    if (!all) {
      var left = vs.filter(function (v) { return !v; }).length;
      totalEl.innerHTML = 'Complete your set to get <strong>' + set.note + '</strong>';
      addBtn.disabled = true;
      addBtn.textContent = left === vs.length ? 'Choose your pieces' : 'Choose ' + left + ' more';
      return;
    }
    totalEl.innerHTML = '<s>' + money(sum) + '</s> <strong>' + money(sum - save) + '</strong> · you save ' + money(save);
    addBtn.disabled = false;
    addBtn.textContent = 'Add set to bag · ' + money(sum - save);
  }

  root.querySelectorAll('input[name="rl-set"]').forEach(function (r) {
    r.addEventListener('change', function () { state.set = r.value; build(); });
  });

  addBtn.addEventListener('click', function () {
    var vs = state.slots.map(variantOf);
    if (!vs.every(Boolean)) return;
    var qty = {};
    vs.forEach(function (v) { qty[v.id] = (qty[v.id] || 0) + 1; });
    addBtn.disabled = true; addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id] }; }) })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add'); });
      location.href = '/cart';
    }).catch(function (err) {
      msgEl.textContent = 'Could not add the set: ' + (err.message === 'add' ? 'please try again.' : err.message);
      total();
    });
  });

  build();
})();
